import { useNavigate } from "react-router-dom";
import Error from "../assets/login/Error.svg";

function ErrorPage() {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1); // Navigate to the previous page
    };

    return (
        <div className="h-screen w-full min-w-[340px]">
            <main className="font-inter flex flex-col lg:flex-col space-y-[64px] items-center justify-center h-screen w-full">
                <img src={Error} alt="" className="w-[312px] h-auto"></img>
                <div className="flex flex-col items-center justify-center text-center lg:text-start">
                    <p className="font-nonito_sans -mt-4 lg:-mt-8 text-black font-bold text-[40px] md:text-[64px]">
                        Page Not Found{" "}
                    </p>
                    <div className="flex flex-col text-center md:flex-row">
                        <p className="font-inter text-[16px] text-light-gray">
                            Couldn't find that.{" "}
                        </p>
                        <button
                            onClick={goBack}
                            className="underline text-black cursor-pointer ml-2"
                        >
                            Safely Go Back?{" "}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default ErrorPage;
